// @ts-check

/**
 * Enumerated type for expedition delete reserves.
 * @type {typeof import('@erpagroapp/types').EliminacionReservaClienteInterno}
 */
export const EliminacionReservaClienteInterno = Object.freeze(/** @satisfies {typeof import('@erpagroapp/types').EliminacionReservaClienteInterno} */ ({
  Nunca: 0,
  Siempre: 1,
  SinGeneracionDeDocumentosAutomaticos: 2,
}));
